export default __webpack_public_path__ + "static/media/modal-avatar.3ab505d9.png";